import { Component, OnDestroy, OnInit } from '@angular/core';
import { DataService } from 'src/app/shared/services/data.service';

@Component({
  selector: 'app-quiz-finished',
  templateUrl: './quiz-finished.component.html',
  styleUrls: ['./quiz-finished.component.scss']
})
export class QuizFinishedComponent implements OnInit,OnDestroy {

  teamId = sessionStorage.getItem('GCGroup');
  isQuizExpired = ''
  constructor(private dataService:DataService) { }
  

  ngOnInit(): void {
    history.pushState(null, null, window.location.href);
    this.completeQuiz()
  }

  completeQuiz(){
    let body = {
      is_completed: 'True'
      // completed_time: Math.floor(Date.now() / 1000)
    }
    this.dataService.studentQuizCompleted(this.teamId,body).subscribe({
      next:(res) =>{
        if (res['data']['status'] == 104){
          this.isQuizExpired = 'yes'
        } else {
          this.isQuizExpired = 'no'
        }
      },
      error:(err) =>{
        console.log(err);
      },
    })
  }

  ngOnDestroy(): void {
    sessionStorage.clear();
  }

}
